import React from "react";
import PendingItemCard from "./PendingItemCard";
import "./StatusCardStyle.css";
import { Grid } from "@mui/material";

const StatusDisplay = ({ statusCount }) => {
  const statuses = [
    {
      label: "Draft",
      count: statusCount?.draft,
      color: "#FFCDD2",
      status: `Draft`,
    },
    {
      label: "Waiting for Review",
      count: statusCount?.submitted,
      color: "#FFECB3",
      status: `Submitted`,
    },
    {
      label: "Waiting for Verification",
      count: statusCount?.reviewed,
      color: "#C8E6C9",
      status: `Reviewed`,
    },
    {
      label: "Hold",
      count: statusCount?.hold,
      color: "#FFCDD2",
      status: `Hold`,
    },
    {
      label: "Waiting for Approval",
      count: statusCount?.verified,
      color: "#BBDEFB",
      status: `Verified`,
    },
  ];
  return (
    // <div
    //   style={{
    //     display: "flex",
    //     gap: "16px",
    //     flexWrap: "wrap",
    //     justifyContent: "flex-start",
    //   }}
    // >
    //   {statuses.map((item, i) => (
    //     <div
    //       key={i}
    //       style={{
    //         flex: "1 1 240px", // ← stretches, but never below 260px
    //         display: "flex",
    //       }}
    //     >
    //       <PendingItemCard
    //         label={item.label}
    //         count={item.count}
    //         status={item.status}
    //         isBtnShow={true}
    //       />
    //     </div>
    //   ))}
    // </div>
   <Grid
  container
  spacing={2}
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      sm: "repeat(2, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(4, 1fr)",
      xl: "repeat(5, 1fr)", // exact 5 items
    },
  }}
>
  {statuses.map((item, i) => (
    <Grid
      item
      key={i}

    >
      <PendingItemCard
        label={item.label}
        count={item.count}
        status={item.status}
        isBtnShow={true}
      />
    </Grid>
  ))}
</Grid>

  );
};

export default StatusDisplay;
